<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-01
      	描述：插件中心-文章-列表
      -->
  <div>
<!--    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addArticle">添加文章</el-button></div>-->
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="user_id" label="会员ID" width="240"></el-table-column>
        <el-table-column prop="name" label="会员等级" width="240"></el-table-column>
        <el-table-column prop="avatarUrl" label="头像" width="250">
          <template slot-scope="scope">
            <img :src="scope.row.avatarUrl" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="nickName" label="用户名"  width="250">
        </el-table-column>

        <el-table-column prop="create_time" label="注册时间" width="240"></el-table-column>
        <el-table-column prop="totalNum" label="订单总数" width="240"></el-table-column>
        <el-table-column prop="name" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="Detail(scope.row.user_id)" type="text" size="small">查看</el-button>
<!--            <el-button @click="deleteArticle(scope.row)" type="text" size="small">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import statisticalApi from '@/api/statistical.js';
  export default {
    components: {},
    data() {
      return {
        /*分类*/
        categoryData: [],
        /*表单数据*/
        tableData: [],
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        commentData: [],
        loading: true,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1
      };
    },
    created() {
      /*获取文章列表*/
      this.getTableList();
    },
    methods: {

      /*获取文章列表*/
      getTableList() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        statisticalApi.salesmanlist(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list;
            // self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.getData();
      },

      handleClick(tab, event) {},



      /*详情*/
      Detail(e) {
        let self = this;
        let user_id = e;
        this.$router.push({
          path: '/plus/statistical/detail/detail',
          query: {
            user_id: user_id
          }
        });
      },


      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/statistical/detail/Index.vue